import dateFns from 'date-fns'

// URL list
import URL from '../../../config.url'

import AppBtn from '../app-btn'
import AppMatchesTableCounter from '../app-matches-table-counter'
import AppArrowLink from '../app-arrow-link'


export default
{
    name: 'app-matches-table-tr',

    components:
    {
        AppBtn,
        AppMatchesTableCounter,
        AppArrowLink
    },

    props:
    {
        subClasses: { type: String, default: '' },
        match: { type: Object },
        contentGlobal: { type: Object },
        contentPage: { type: Object }
    },

    data()
    {
        return {
            teamA: { },
            teamB: { }
        }
    },

    created()
    {
        this._now = Math.round(new Date().getTime() / 1000)

        this.teamA = this._getTeamFromID(this.match.teamOneID)
        this.teamB = this._getTeamFromID(this.match.teamTwoID)
    },

    methods:
    {
        _getTeamFromID(id)
        {
            return this.contentGlobal.teamsAll.find(team => team.id === id)
        },

        _getVideoGameFromID(id)
        {
            return this.contentGlobal.videoGames.find(team => team.id === id)
        },

        getMatchUrlBySlug(slug)
        {
            if (this._getLive())
            {
                return this.$root.getPageURLFromID('watchNow')
            }

            return this.$root.getPageURLFromID('esMatchDetails').replace(':slug', slug)
        },

        _getStatus()
        {
            if (this._now >= this.match.dateStart && this.match.status !== 'pending')
            {
                return 'is-past'
            }
            else if (dateFns.isToday(this.match.dateStart * 1000))
            {
                return 'is-today'
            }

            return 'is-upcoming'
        },

        _getLive()
        {
            return this._now >= this.match.dateStart && this.match.status === 'pending'
        },

        _getLink()
        {
            if (this._getLive())
            {
                return this.$root.getPageURLFromID('watchNow')
            }
            else
            {
                return this.$root.getPageURLFromID('esMatchDetails').replace(':slug', this.match.slug)
            }
        },

        _scoreIsSuperior(one, two)
        {
            return one - two
        },

        _getDateFormatted(timestamp)
        {
            return (dateFns.format(timestamp * 1000, 'DD.MM.YYYY [-] hh[<sup>]A[</sup>] mm'))
        }

        /* _getBeginsIn()
        {
            let dif = this.match.dateStart - this._now

            if (dif > 60 * 60 * 24 * 2)
            {
                const days = Math.floor(dif / (60 * 60 * 24))

                dif = days + ' days'
            }
            else if (dif > 60 * 60 * 24)
            {
                const days = Math.floor(dif / (60 * 60 * 24))

                dif = days + ' day'
            }
            else
            {
                const hours = Math.floor(dif / 3600)
                dif %= 3600
                const minutes = Math.round(dif / 60)

                dif = hours + '<span class="t-text--xs u-valign-top u-marg-t-xs">H</span>' + minutes + '<span class="t-text--xs u-valign-top">M</span>'
            }

            return dif
        }*/
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-matches-table-tr/script.js